import { useEffect } from "react";
import { useUrlParamsContext, useTheme } from "src/contexts";

export const useThemeInitializer = () => {
  const { theme: urlTheme, exchange } = useUrlParamsContext();
  const { onSetTheme, onSetExchange } = useTheme();

  useEffect(() => {
    if (urlTheme) {
      onSetTheme(urlTheme);
    }
    onSetExchange(exchange);
  }, [urlTheme, exchange, onSetTheme, onSetExchange]);
};
